module.exports = __webpack_public_path__ + "static/media/map-marker-night.e3c0bd81.svg";